export { WebAdapter } from './web-adapter';

